import { Popover, Text } from '@shared/components';
import { useEmailThreadContext } from '@shared/contexts/pluginContexts/EmailThreadContext';
import { uniq } from 'lodash';
import { useState } from 'react';

export const SharedInboxNotice = () => {
  const { sharedInbox } = useEmailThreadContext();
  const { isSharedInbox, address, candidates, selectCandidate } = sharedInbox;
  const [popoverOpen, setPopoverOpen] = useState(false);

  const sharedMailboxOptions = uniq([
    ...(address ? [address] : []),
    ...candidates,
  ]);

  const shouldAllowSelectSharedInbox = sharedMailboxOptions?.length >= 1;

  const getOptions = () => {
    return (
      <div className="flex flex-col py-2">
        <div
          onClick={() => {
            selectCandidate();
            setPopoverOpen(false);
          }}
          className="flex cursor-pointer p-2 hover:bg-gray-100"
        >
          <Text type="body-sm">Not a shared mailbox</Text>
        </div>
        {sharedMailboxOptions?.map((email, idx) => (
          <div
            key={`${email}-${idx}`}
            onClick={() => {
              selectCandidate(email);
              setPopoverOpen(false);
            }}
            className="flex cursor-pointer p-2 hover:bg-gray-100"
          >
            <Text type="body-sm">{email}</Text>
          </div>
        ))}
      </div>
    );
  };

  return isSharedInbox ? (
    <div className="mt-2 flex justify-center px-8">
      <Text type="body-xs" className="truncate text-ellipsis text-gray-400">
        {!shouldAllowSelectSharedInbox && (
          <>Using Vooma in shared mailbox {address}</>
        )}
        {shouldAllowSelectSharedInbox && (
          <Popover
            content={getOptions()}
            side="bottom"
            align="start"
            open={popoverOpen}
            onOpenChange={setPopoverOpen}
          >
            <div className="flex gap-1">
              Using Vooma in shared mailbox
              <div
                className="cursor-pointer"
                onClick={() => setPopoverOpen(true)}
              >
                <Text type="body-xs" className="text-brand-500">
                  {address}
                </Text>
              </div>
            </div>
          </Popover>
        )}
      </Text>
    </div>
  ) : null;
};
